import '.f1{transition:all .2s ease-out;}.ssr-plugin'
import '.f2{margin:-8px -16px;}.ssr-plugin'
import '.f3{padding:8px 16px;}.ssr-plugin'
import '.f4{border-radius:24px;}.ssr-plugin'
import '.f5{border:1px solid transparent;}.ssr-plugin'
import '.f6{scale:1;}.ssr-plugin'
import '.cp{max-width:480px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.i{height:100%;}.ssr-plugin'
import '.er{margin-left:8px;}.ssr-plugin'
import '.es{margin-right:8px;}.ssr-plugin'
import '.et{max-height:calc(100vh - 192px);}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.ee{backdrop-filter:blur(48px);}.ssr-plugin'
import '.ef{-webkit-backdrop-filter:blur(48px);}.ssr-plugin'
import '.d3{flex-direction:row;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.eu{padding:20px 24px;}.ssr-plugin'
import '.ev{font-size:20px;}.ssr-plugin'
import '.ew{margin-top:4px;}.ssr-plugin'
import '.ex{overflow-y:scroll;}.ssr-plugin'
import '.ey{scrollbar-width:none;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.b3{margin-bottom:16px;}.ssr-plugin'
import '.ca{text-align:left;}.ssr-plugin'
import '.f0{margin:24px auto;}.ssr-plugin'
import '.as{gap:16px;}.ssr-plugin'
import { useQuery } from '@based'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import {
  useVotingRegion,
  useVotingRegionName,
  getVotingRegionName,
} from '../hooks/useVotingRegion.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { MOBILE } from '../utils/breakpoints.js'
import { useTranslations } from '../hooks/useTranslations.js'
import { useLanguage } from '../hooks/useLanguage.js'
import { useLocation } from 'wouter'
import { defaultRegion } from '../hooks/useSelectedVotingRegion.js'

const VotingRegionItem = ({ code, onSelect }) => {
  const name = useVotingRegionName(code)
  return (
    <styled.a className="f1 f2 f3 f4 f5 f6"
      id={`language-modal-action-set-voting-region-${code}`}
      style={{
        '&:hover': {
          background: `${colors.border}`,
          border: `1px solid ${colors.border}`,
          scale: '.98',
        },
      }}
      onClick={onSelect}
    >
      {name} <Icon type="chevronRightIcon" />
    </styled.a>
  )
}

export const SelectVotingRegionModal = ({ setModal }) => {
  const track = useTrack('menu')
  const [votingRegion, setVotingRegion] = useVotingRegion()

  const { data: navigationTranslation } = useTranslations('Navigation')
  const [lang] = useLanguage()

  const [location, setLocation] = useLocation()

  const { data: participatingVotingRegions } = useQuery(
    'participating-voting-regions',
  )

  const votingRegionsCodes =
    participatingVotingRegions &&
    Object.keys(participatingVotingRegions)
      .filter((item) => !participatingVotingRegions[item].isTerritoryOf)
      .sort((a, b) =>
        getVotingRegionName(a, lang.code).localeCompare(
          getVotingRegionName(b, lang.code),
          lang.code,
        ),
      )

  return (
    <ModalWrapper onDismiss={() => setModal(false)}>
      <styled.div className="cp a i er es et ag cq o p ee ef"
        style={{
          backgroundColor: `${transparentColor(colors.secondary, 0.1)}`,
          border: `1px solid ${colors.border}`,
          animation: MODAL_PANEL_ANIMATION,
          [MOBILE]: {
            maxHeight: 'calc(100vh - 16px)',
            backgroundColor: `${transparentColor(colors.secondary, 0.8)}`,
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          },
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="o d3 am v eu"
          style={{
            borderBottom: `1px solid ${colors.border}`,
          }}
        >
          <h3 className="ev ew">
            {navigationTranslation?.selectVotingRegion}
          </h3>
          <IconButton
            id="voting-region-modal-action-close-button"
            variant="ghost"
            icon={<Icon type="closeIcon" />}
            onClick={() => setModal(false)}
          />
        </div>
        <styled.div className="ex ey f eu"
          style={{
            '& a': {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              userSelect: 'none',
            },
          }}
        >
          <p className="subtext b3 ca"
          >
            {navigationTranslation?.basedOnYourLocation}
          </p>
          <styled.a className="f1 f2 f3 f4 f5 f6"
            style={{
              '&:hover': {
                background: `${colors.border}`,
                border: `1px solid ${colors.border}`,
                scale: '.98',
              },
            }}
            onClick={() => {
              track(
                AnalyticsEvent.MENU_REGION_CHANGE,
                `${votingRegion.code}->ROW`,
              )
              setVotingRegion('ROW')
              setModal(false)
              setLocation('/')
            }}
          >
            {getVotingRegionName(defaultRegion, lang.code)}
            <Icon type="chevronRightIcon" />
          </styled.a>
          <div className="a f0"
            style={{
              backgroundColor: colors.border,}}
          />
          <p className="subtext b3 ca"
          >
            {navigationTranslation?.allVotingRegions}
          </p>
          <div className="o p as"
          >
            {votingRegion?.code !== 'ROW' && (
              <VotingRegionItem
                code={'ROW'}
                onSelect={() => {
                  track(
                    AnalyticsEvent.MENU_REGION_CHANGE,
                    `${votingRegion.code}->ROW`,
                  )
                  setVotingRegion('ROW')
                  setModal(false)
                  setLocation('/')
                }}
              />
            )}
            {votingRegionsCodes
              ?.filter((item) => item !== 'ROW')
              ?.map((item) => (
                <VotingRegionItem
                  key={item}
                  code={item}
                  onSelect={() => {
                    track(
                      AnalyticsEvent.MENU_REGION_CHANGE,
                      `${votingRegion.code}->${item}`,
                    )
                    setVotingRegion(item)
                    setModal(false)
                    setLocation('/')
                  }}
                />
              ))}
          </div>
        </styled.div>
      </styled.div>
    </ModalWrapper>
  )
}
